import { Component, Input } from '@angular/core';
import { IDashboardHeader } from 'common';

@Component({
  selector: 'acc-dashboard-header',
  templateUrl: './dashboard-header.component.html',
  styleUrl: './dashboard-header.component.scss'
})
export class DashboardHeaderComponent {

  @Input() card: IDashboardHeader;

  constructor() { }


  public get isSvgIcon(): boolean {
    return this.card.iconIsSvg === true;
  }

  public get isMatIcon(): boolean {
    return this.card.iconIsSvg === false;
  }

}


